export default __webpack_public_path__ + "static/media/dollar.2361ca38.svg";